export default (state = {}, action) => ({
  ...state,
  loading: action ? action.param || false : false
});
